<template>
  <ul>
    <li v-for="item in items.filter(x => x.Selected)" :key="item.Id">
      <strong>{{ item.OemPartCode }}</strong>
      <template v-if="item.McfPartCode">
        | {{ item.McfPartCode }}
      </template>
      <template v-if="item.PartDescription">
        | {{ item.PartDescription }}
      </template>
      <span>(Qty: {{ item.Quantity }})</span>
    </li>
  </ul>
</template>

<script>
  export default {
    name: "PartListing",
    props: {
      items: {
        type: Array,
        default: function() {
          return []
        }
      }
    }
  }
</script>
